require('./lbaCompanyReference.scss');
const $inject = [];
const lbaCompanyReference = function () {
  return {
    restrict: 'A',
    scope: {
      settings: '<',
    },
    bindToController: true,
    controller: 'lbaCompanyReferenceCtrl',
    controllerAs: 'vm',
    template: require('./lbaCompanyReference.html')
  }
};

lbaCompanyReference.$inject = $inject;

export default lbaCompanyReference;


// WEBPACK FOOTER //
// ./src/components/lbaCompanyReference/lbaCompanyReferenceDir.js